import PageSectionBlock from './sections/tab_dnd/PageSection';
import PageSectionMap from './sections/tab_dnd/PageSection';
import PageSectionForm from './sections/tab_dnd/PageSection';
import PageSectionPrices from './sections/tab_dnd/PageSection';
import PageSectionReviews from './sections/tab_dnd/PageSection';
import PageSectionTeamMembers from './sections/tab_dnd/PageSection';
import PageSectionRecentlyViewed from './sections/tab_dnd/PageSection';
import PageSectionProjectOverview from './sections/tab_dnd/PageSection';
import PageSectionProductPartners from './sections/tab_dnd/PageSection';
import PageSectionProductItinerary from './sections/tab_dnd/PageSection';
import PageSectionTripFormats from './sections/tab_dnd/PageSection';
import PageSectionInternalLinks from './sections/tab_dnd/PageSection';
import PageSectionText from './sections/tab_dnd/PageSection';
import PageSectionCallToAction from './sections/tab_dnd/PageSection';
import PageSectionSharing from './sections/tab_dnd/PageSection';
import PageSectionAuthor from './sections/tab_dnd/PageSection';
import PageSectionLinkTo from './sections/tab_dnd/PageSection';
import PageSectionProductsList from './sections/tab_dnd/PageSection';
import PageSectionNextSteps from './sections/tab_dnd/PageSection';
import PageSectionReviewSnippets from './sections/tab_dnd/PageSection';
import PageSectionFaqs from './sections/tab_dnd/PageSection';
import PageSectionSearchResults from './sections/tab_dnd/PageSection';
import PageSectionFindYourProject from './sections/tab_dnd/PageSection';
import PageSectionLargeSnippets from './sections/tab_dnd/PageSection';
import PageSectionValueProposition from './sections/tab_dnd/PageSection';
import PageSectionGroupTripsBanner from './sections/tab_dnd/PageSection';
import PageSectionMeetUs from './sections/tab_dnd/PageSection';
import PageSectionTripFormatsCarousel from './sections/tab_dnd/PageSection';
import PageSectionBlogSnippets from './sections/tab_dnd/PageSection';
import PageSectionEvents from './sections/tab_dnd/PageSection';
import PageSectionOpendaysTable from './sections/tab_dnd/PageSection';
import PageSectionStaffProfiles from './sections/tab_dnd/PageSection';

export const SECTION_TYPE_TEXT = 1;
export const SECTION_TYPE_BLOCK = 2;
export const SECTION_TYPE_MAP = 3;
export const SECTION_TYPE_PRICE = 4;
export const SECTION_TYPE_FORM = 5;
export const SECTION_TYPE_REVIEWS = 7;
export const SECTION_TYPE_STAFF = 8;
export const SECTION_TYPE_INTERNAL_LINK_SNIPPET = 9;
export const SECTION_TYPE_PRODUCT_SNIPPET = 10;
export const SECTION_TYPE_TRIP_FORMAT_SNIPPET = 11;
export const SECTION_TYPE_CALL_TO_ACTION = 12;
export const SECTION_TYPE_ITINERARY = 13;
export const SECTION_TYPE_PARTNERS = 14;
export const SECTION_TYPE_OVERVIEW = 15;
export const SECTION_TYPE_RECENTLY_VIEWED = 16;
export const SECTION_TYPE_NEXT_STEPS = 17;
export const SECTION_TYPE_REVIEW_SNIPPETS = 18;
export const SECTION_TYPE_OPENDAYS_TABLE = 19;
export const SECTION_TYPE_FAQS = 20;
export const SECTION_TYPE_STAFF_PROFILES = 21;
export const SECTION_TYPE_SEARCH_RESULTS = 22;
export const SECTION_TYPE_FIND_YOUR_PROJECT = 23;
export const SECTION_TYPE_LARGE_SNIPPETS = 24;
export const SECTION_TYPE_VALUE_PROPOSITION = 25;
export const SECTION_TYPE_GROUP_TRIPS_BANNER = 26;
export const SECTION_TYPE_MEET_US = 27;
export const SECTION_TYPE_TRIP_FORMATS_CAROUSEL = 28;
export const SECTION_TYPE_EVENTS = 29;
export const SECTION_TYPE_SHARING = 30;
export const SECTION_TYPE_AUTHOR = 31;
export const SECTION_TYPE_LINK_TO = 32;
export const SECTION_TYPE_BLOG_SNIPPETS = 33;

export const sections = {
    [SECTION_TYPE_TEXT] : PageSectionText,
    [SECTION_TYPE_BLOCK] : PageSectionBlock,
    [SECTION_TYPE_MAP] : PageSectionMap,
    [SECTION_TYPE_PRICE] : PageSectionPrices,
    [SECTION_TYPE_FORM] : PageSectionForm,
    [SECTION_TYPE_TRIP_FORMAT_SNIPPET] : PageSectionTripFormats,
    [SECTION_TYPE_PRODUCT_SNIPPET] : PageSectionProductsList,
    [SECTION_TYPE_REVIEWS] : PageSectionReviews,
    [SECTION_TYPE_STAFF] : PageSectionTeamMembers,
    [SECTION_TYPE_INTERNAL_LINK_SNIPPET] : PageSectionInternalLinks,
    [SECTION_TYPE_RECENTLY_VIEWED] : PageSectionRecentlyViewed,
    [SECTION_TYPE_OVERVIEW] : PageSectionProjectOverview,
    [SECTION_TYPE_PARTNERS] : PageSectionProductPartners,
    [SECTION_TYPE_ITINERARY] : PageSectionProductItinerary,
    [SECTION_TYPE_CALL_TO_ACTION] : PageSectionCallToAction,
    [SECTION_TYPE_SHARING] : PageSectionSharing,
    [SECTION_TYPE_AUTHOR] : PageSectionAuthor,
    [SECTION_TYPE_LINK_TO] : PageSectionLinkTo,
    [SECTION_TYPE_NEXT_STEPS] : PageSectionNextSteps,
    [SECTION_TYPE_REVIEW_SNIPPETS] : PageSectionReviewSnippets,
    [SECTION_TYPE_FAQS] : PageSectionFaqs,
    [SECTION_TYPE_SEARCH_RESULTS] : PageSectionSearchResults,
	[SECTION_TYPE_FIND_YOUR_PROJECT] : PageSectionFindYourProject,
	[SECTION_TYPE_LARGE_SNIPPETS] : PageSectionLargeSnippets,
	[SECTION_TYPE_VALUE_PROPOSITION] : PageSectionValueProposition,
	[SECTION_TYPE_GROUP_TRIPS_BANNER] : PageSectionGroupTripsBanner,
	[SECTION_TYPE_MEET_US] : PageSectionMeetUs,
	[SECTION_TYPE_TRIP_FORMATS_CAROUSEL] : PageSectionTripFormatsCarousel,
    [SECTION_TYPE_BLOG_SNIPPETS] : PageSectionBlogSnippets,
    [SECTION_TYPE_EVENTS] : PageSectionEvents,
    [SECTION_TYPE_OPENDAYS_TABLE] : PageSectionOpendaysTable,
    [SECTION_TYPE_STAFF_PROFILES] : PageSectionStaffProfiles,
};


// WEBPACK FOOTER //
// ./src/containers/templates/builder/constants.js